import React from 'react';
import PropTypes from 'prop-types';

import {
    Table,
} from '@zillow/constellation';

import { StyledTable } from './StyledComponents';

const propTypes = {
    tableData: PropTypes.object.isRequired,
};

function CustomTable({ tableData }) {
    const { rowList, footer, errorMessage } = tableData;
    const rowLength = tableData.rowList.length;
    const errorMsg = errorMessage || 'No results found';

    return (
        <>
            <StyledTable appearance="horizontal" aria-label="Small-sized horizontal table" size="sm">
                {tableData.headerList}
                <Table.Body>
                    {rowList}
                    {footer}
                </Table.Body>
            </StyledTable>
            {rowLength === 0 && <div className="Table-error">{errorMsg}</div>}
        </>
    );
}

CustomTable.propTypes = propTypes;

export { CustomTable };
export default CustomTable;
